export const GET_MARKET_LIST = `/api/v1/market/conf/v2/list`;
export const GET_NEWEST_MARKET_LIST = `/api/v1/market/otc/v2/latest`;
